import { QUESTIONS as QUESTIONS_A_220_1201 } from './220-1201/questions'
import { QUESTIONS as QUESTIONS_A_220_1202 } from './220-1202/questions'
import { QUESTIONS as QUESTIONS_CLOUD_CV0_004 } from './Cloud+/questions'
import { QUESTIONS as QUESTIONS_CYSA_CS0_003 } from './CySA+/questions'
import { QUESTIONS as QUESTIONS_DATASYS_DS0_001 } from './DataSys+/questions'
import { QUESTIONS as QUESTIONS_DATAX_DX0_001 } from './DATAX/questions'
import { QUESTIONS as QUESTIONS_LINUX_XK0_006 } from './Linux+/questions'
import { QUESTIONS as QUESTIONS_NETWORK_N10_009 } from './Network+/questions'
import { QUESTIONS as QUESTIONS_PENTEST_PT0_003 } from './PenTest+/questions'
import { QUESTIONS as QUESTIONS_PROJECT_PK0_005 } from './Project+/questions'
import { QUESTIONS as QUESTIONS_SECURITY_SY0_701 } from './Security+/questions'
import { QUESTIONS as QUESTIONS_SERVER_SK0_005 } from './Server+/questions'

import { FLASHCARDS as FLASHCARDS_A_220_1201 } from './220-1201/flashcards'
import { FLASHCARDS as FLASHCARDS_A_220_1202 } from './220-1202/flashcards'
import { FLASHCARDS as FLASHCARDS_CLOUD_CV0_004 } from './Cloud+/flashcards'
import { FLASHCARDS as FLASHCARDS_CYSA_CS0_003 } from './CySA+/flashcards'
import { FLASHCARDS as FLASHCARDS_DATASYS_DS0_001 } from './DataSys+/flashcards'
import { FLASHCARDS as FLASHCARDS_DATAX_DX0_001 } from './DATAX/flashcards'
import { FLASHCARDS as FLASHCARDS_LINUX_XK0_006 } from './Linux+/flashcards'
import { FLASHCARDS as FLASHCARDS_NETWORK_N10_009 } from './Network+/flashcards'
import { FLASHCARDS as FLASHCARDS_PENTEST_PT0_003 } from './PenTest+/flashcards'
import { FLASHCARDS as FLASHCARDS_PROJECT_PK0_005 } from './Project+/flashcards'
import { FLASHCARDS as FLASHCARDS_SECURITY_SY0_701 } from './Security+/flashcards'
import { FLASHCARDS as FLASHCARDS_SERVER_SK0_005 } from './Server+/flashcards'

// Articles load lazily (one webpack chunk per cert) — see LOAD_ARTICLES below — so the
// large article bodies stay out of the initial bundle.

export const BUNDLE_QUESTIONS = {
  '220-1201': QUESTIONS_A_220_1201,
  '220-1202': QUESTIONS_A_220_1202,
  'Cloud+': QUESTIONS_CLOUD_CV0_004,
  'CySA+': QUESTIONS_CYSA_CS0_003,
  'DataSys+': QUESTIONS_DATASYS_DS0_001,
  'DATAX': QUESTIONS_DATAX_DX0_001,
  'Linux+': QUESTIONS_LINUX_XK0_006,
  'Network+': QUESTIONS_NETWORK_N10_009,
  'PenTest+': QUESTIONS_PENTEST_PT0_003,
  'Project+': QUESTIONS_PROJECT_PK0_005,
  'Security+': QUESTIONS_SECURITY_SY0_701,
  'Server+': QUESTIONS_SERVER_SK0_005
}

export const BUNDLE_FLASHCARDS = {
  '220-1201': FLASHCARDS_A_220_1201,
  '220-1202': FLASHCARDS_A_220_1202,
  'Cloud+': FLASHCARDS_CLOUD_CV0_004,
  'CySA+': FLASHCARDS_CYSA_CS0_003,
  'DataSys+': FLASHCARDS_DATASYS_DS0_001,
  'DATAX': FLASHCARDS_DATAX_DX0_001,
  'Linux+': FLASHCARDS_LINUX_XK0_006,
  'Network+': FLASHCARDS_NETWORK_N10_009,
  'PenTest+': FLASHCARDS_PENTEST_PT0_003,
  'Project+': FLASHCARDS_PROJECT_PK0_005,
  'Security+': FLASHCARDS_SECURITY_SY0_701,
  'Server+': FLASHCARDS_SERVER_SK0_005
}

// Per-cert lazy article loaders — each import() is its own webpack chunk, fetched only
// when articles are needed. Consumed via the shared GET_ARTICLES (async).
const ARTICLE_LOADERS = {
  '220-1201': () => import('./220-1201/articles'),
  '220-1202': () => import('./220-1202/articles'),
  'Cloud+': () => import('./Cloud+/articles'),
  'CySA+': () => import('./CySA+/articles'),
  'DataSys+': () => import('./DataSys+/articles'),
  'DATAX': () => import('./DATAX/articles'),
  'Linux+': () => import('./Linux+/articles'),
  'Network+': () => import('./Network+/articles'),
  'PenTest+': () => import('./PenTest+/articles'),
  'Project+': () => import('./Project+/articles'),
  'Security+': () => import('./Security+/articles'),
  'Server+': () => import('./Server+/articles'),
}

export const LOAD_ARTICLES = async (cert) => {
  const loader = ARTICLE_LOADERS[cert]
  if (!loader) return []
  const mod = await loader()
  return mod?.ARTICLES ?? []
}

// Static article counts so stats stay instant without loading article bodies. These
// literals are guarded by `npm run verify:article-counts` (also chained into
// `npm run build`), which recomputes them from the articles.js files and fails on
// mismatch — so a content update can't silently desync the displayed counts.
export const BUNDLE_ARTICLE_COUNTS = {
  '220-1201': 235,
  '220-1202': 314,
  'Cloud+': 229,
  'CySA+': 267,
  'DataSys+': 150,
  'DATAX': 196,
  'Linux+': 462,
  'Network+': 402,
  'PenTest+': 332,
  'Project+': 333,
  'Security+': 320,
  'Server+': 227
}

export const BUNDLE_GLOSSARY = {}

export const BUNDLE_ACRONYMS = {}
